export const formatFileImportLabel = (value) => {
  if (!value) return '-';

  return value
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
};

export const getFileNameFromDisposition = (disposition, fallback) => {
  const match = disposition?.match(/filename="?([^";]+)"?/i);
  return match?.[1] || fallback || 'source-file.csv';
};
